import { EdgesGeometry } from '../../thirdparty/three/imports';
import { watcher } from '../../watcher/watcher';
import { BufferGeometry3D } from '../core/BufferGeometry3D';

export class EdgesGeometry3D extends BufferGeometry3D
{
    geometry?: BufferGeometry3D;

    get _geometry()
    {
        if (!this.__geometry)
        {
            this.__geometry = new EdgesGeometry(this.geometry._geometry);
        }

        return this.__geometry;
    }
    declare protected __geometry: EdgesGeometry;

    constructor()
    {
        super();
        watcher.watchs(this as EdgesGeometry3D, ['geometry'], this._invalidate, this);
    }

    destroy()
    {
        watcher.unwatchs(this as EdgesGeometry3D, ['geometry'], this._invalidate, this);
    }
}
